import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  GetAllBussinessAddressesListPayloadType,
  GetAllLedgersListPayloadType,
} from "../../commonTypes/clientSettingsTypes";
import {
  PaperClipIcon,
  PlusIconCircle,
  UploadNew,
} from "../../components/Icon";
import OtherEntryForm from "../../components/InvoiceGeneration/OtherEntry/OtherEntryForm";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { resetSession } from "../../redux/auth";
import {
  getAllBusinessAddressAction,
  getAllTypesWithTaxListAction,
} from "../../redux/clientSettings";
import {
  AllLedgersListType,
  BusinessAddressListType,
} from "../../redux/clientSettings/clientSettingTypes";
import { RootState } from "../../redux/rootReducers";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Verified, Warning } from "../../assets/images";
import { ImageDataType } from "../../commonTypes/fileManagerTypes";
import {
  AddCommentPayloadType,
  AddOtherInvoiceGenerationPayloadType,
  ApproveInvoicePayloadType,
  GetAllocationPayloadType,
  GetCommentPayloadType,
  GetSingleOtherInvoiceDetailsPayloadType,
  OtherInvoiceGenerationPaymentType,
  SingleAllocationPayloadListType,
  UpdateOtherInvoiceGenerationPayloadType,
} from "../../commonTypes/invoiceGenerationTypes";
import ImagePreview from "../../components/FileManager/Files/ImagePreview";
import AllocationModal from "../../components/InvoiceGeneration/AllocationModal/AllocationModal";
import InvoiceCommentsModal from "../../components/InvoiceGeneration/InvoiveCommentsModal";
import UploadModalWithFileManager from "../../components/InvoiceGeneration/UploadModal/UploadModalWithFileManager";
import Avatar from "../../components/commons/CircularAvatar/CircularAvatar";
import RedirectErrorSuccessModal from "../../components/commons/ErrorSuccessModal/RedirectErrorSuccessModal";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  addOtherInvoiceGenerationAction,
  approveInvoiceAction,
  getAllAllocationListAction,
  getInvoiceAllComment,
  getPaymentPendingList,
  getSingleOtherInvoiceDetailsAction,
  postInvoiceAllComment,
  resetAllAllocationList,
  resetAllocationList,
  resetApprovalSuccess,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetSingleOtherInvoiceDetails,
  resetcommentsSuccess,
  updateOtherInvoiceGenerationAction,
} from "../../redux/invoiceGeneration";
import { AllocationListType } from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import {
  checkSameUserId,
  formatDate,
  formateDateWithTime,
} from "../../utils/commonFunctions";
import {
  downloadLink,
  imagePreview,
  renderUploadedFiles,
} from "../../utils/invoiceGeneration/commonFunctions";

type TransactionType = {
  value: string;
  label: string;
};

export const TRANSACTION_TYPES: TransactionType[] = [
  {
    value: "debit",
    label: "Sent(Debit)",
  },
  {
    value: "credit",
    label: "Received(Credit)",
  },
];

export type ItemTypes = {
  others_payment_id?: number;
  transaction_type?: Object | null;
  account_details?: object | null;
  allocated_data?: [];
  amount?: string | null;
};

const ITEM_DATA: ItemTypes[] = [
  {
    transaction_type: {},
    account_details: {},
    amount: null,
  },
];

export type OtherErrorType = {
  dateOfInvoiceError: string;
  narrationInBankError: string;
  branchError: string;
};

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  message: string | null;
  allLedgersList: AllLedgersListType[] | [];
  businessAddressList: [] | BusinessAddressListType[];
  singleOtherInvoiceDetails: any;
  fileManagerFetching: boolean;
  currencySign: string | undefined;
  dispatchResetSessionAction: () => void;
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) => void;
  dispatchAddOtherInvoiceGenerationAction: (
    data: AddOtherInvoiceGenerationPayloadType
  ) => void;
  dispatchUpdateOtherInvoiceGenerationAction: (
    data: UpdateOtherInvoiceGenerationPayloadType
  ) => void;
  dispatchResetInvoiceGenerationError: () => void;
  dispatchResetInvoiceGenerationSuccess: () => void;
  dispatchGetSingleOtherInvoiceDetails: (
    data: GetSingleOtherInvoiceDetailsPayloadType
  ) => void;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetSingleOtherInvoiceDetailsAction: () => void;
  loginData: LoginResponseType;
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) => void;
  approvalSuccess: null | number;
  commentsSuccess: null | number;
  dispatchResetApprovalSuccess: () => void;
  dispatchResetCommentsSuccess: () => void;
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) => void;
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) => void;
  dispatchResetPaymentPendingListAction: () => void;
  dispatchResetAllAllocationListAction: () => void;
  allComments: any;
  paymentPendingList: [] | AllocationListType[];
  allAllocationList: [] | AllocationListType[];
  lockedOthersEntriesDate: null | string;
  dispatchGetPaymentPendingListAction: (data: GetAllocationPayloadType) => void;
  dispatchGetAllAllocationListAction: (data: GetAllocationPayloadType) => void;
};

type BranchType = {
  value: number | undefined;
  label: string;
};

const AddEditOtherEntryInvoice = ({
  history,
  fetching,
  token,
  error,
  success,
  message,
  currencySign,
  statusCode,
  allLedgersList,
  businessAddressList,
  fileManagerFetching,
  lockedOthersEntriesDate,
  dispatchResetPaymentPendingListAction,
  dispatchResetAllAllocationListAction,
  dispatchResetSessionAction,
  dispatchGetAllLedgerListAction,
  dispatchAddOtherInvoiceGenerationAction,
  dispatchUpdateOtherInvoiceGenerationAction,
  dispatchResetSingleOtherInvoiceDetailsAction,
  dispatchResetInvoiceGenerationError,
  dispatchResetInvoiceGenerationSuccess,
  dispatchGetSingleOtherInvoiceDetails,
  singleOtherInvoiceDetails,
  dispatchGetAllBusinessAddressAction,
  loginData,
  dispatchApproveInvoice,
  approvalSuccess,
  commentsSuccess,
  paymentPendingList,
  allAllocationList,
  dispatchGetPaymentPendingListAction,
  dispatchGetAllAllocationListAction,
  dispatchResetApprovalSuccess,
  dispatchResetCommentsSuccess,
  dispatchGetAllInvoiceCommentsAction,
  dispatchPostAllInvoiceCommentsAction,
  allComments,
}: AppProps) => {
  const search = useLocation().search;
  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");
  const searchOtherData = history?.location?.state?.searchOtherData;
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams;
  const client_code: number = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams;
  const editData = singleOtherInvoiceDetails;

  let { invoice_id, id }: any = useParams();

  invoice_id = invoice_id?.split("?")[0];
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const [narrationInBank, setNarrationInBank] = useState<string>("");
  const [dateOfInvoice, setDateOfInvoice] = useState<any>();
  const [itemData, setItemData] = useState(
    JSON.parse(JSON.stringify(ITEM_DATA))
  );
  const [totalAmount, setTotalAmount] = useState<number | string | any>(0);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [additionalComments, setAdditionalComments] = useState<string>("");
  const [uploadData, setUploadData] = useState<any>([]);
  const [totalAmountError, setTotalAmountError] = useState<boolean>(false);
  const [otherErrors, setOtherErrors] = useState<OtherErrorType>({
    dateOfInvoiceError: "",
    narrationInBankError: "",
    branchError: "",
  });
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [branch, setBranch] = useState<BranchType>({
    label: "Choose branch name...",
    value: undefined,
  });
  const [approved, setApproved] = useState(false);
  const [showInvoiceCommentsModal, setShowInvoiceCommentsModal] =
    useState<boolean>(false);
  const [invoiceData, setInvoiceData] = useState<any>(null); //comment model data
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const redirection = localStorage.getItem("isRedirected");
  const [showAllocationModal, setShowAllocationModal] = useState(false);

  //============================User Management===========================
  const [isApproveOthersInvoice, setIsApproveOthersInvoice] = useMenuCheck();
  const [isAddOthersInvoiceComments, setIsAddOthersInvoiceComments] =
    useMenuCheck();
  const [isEditOthersInvoicePresent, setIsEditOthersInvoicePresent] =
    useMenuCheck();
  const [isAddOthersInvoicePresent, setIsAddOthersInvoicePresent] =
    useMenuCheck();
  const [isViewOthersInvoicePresent, setIsViewOthersViewInvoicePresent] =
    useMenuCheck();
  //=============================================================================

  const [attachment, setAttachment] = useState<string>("");
  const [approval, setApproval] = useState<string>("");
  const [auditSeasonMessage, setAuditSeasonMessage] = useState("");
  const [paymentPendingData, setPaymentPendingData] = useState<any[] | []>([]);
  const [allocatedAmount, setAllocatedAmount] = useState<number>(0);
  const [remainingAmount, setRemainingAmount] = useState<number>(0);
  const [persistAllocatedAmount, setPersistAllocatedAmount] =
    useState<number>(0);
  const [allocationSingleRowData, setAllocationSingleRowData] = useState<any>(
    {}
  );
  const [allAllocatedPaymentRowsData, setAllAllocatedPaymentRowData] =
    useState<any>({});
  const [isAllocatedRowClear, setIsAllocatedRowClear] = useState<any>({});
  const [isEntryLocked, setIsEntryLocked] = useState(false);
  const otherAttachement = history?.location?.state?.attachment;
  const otherApproval = history?.location?.state?.approved;
  const invoiceDataOtherValue = history?.location?.state?.invoiceDataOtherValue;
  const invoiceNumberOtherValue =
    history?.location?.state?.invoiceNumberOtherValue;
  const otherComment = history?.location?.state?.comment;
  const otherStartDate = history?.location?.state?.filterStartDate;
  const otherEndDate = history?.location?.state?.filterEndDate;
  const otherInvoiceStartDate =
    history?.location?.state?.filterInvoiceStartDate;
  const otherInvoiceEndDate = history?.location?.state?.filterInvoiceEndDate;
  const otherRadioValue = history?.location?.state?.radioValue;

  useEffect(() => {
    if (
      history?.location?.state?.approved ||
      history?.location?.state?.attachment
    ) {
      setAttachment(history?.location?.state?.attachment);
      setApproval(history?.location?.state?.approved);
    }
  }, [history?.location?.state]);

  useEffect(() => {
    if (showAllocationModal) {
      let sum: number = 0;
      let inputValue: number = 0;
      allAllocatedPaymentRowsData[
        allocationSingleRowData?.othersPaymentId
      ]?.map((item: any) => {
        sum += +item?.remaining_amount;
        inputValue += +item?.singleAmount;
      });
      setRemainingAmount(sum);
      let finalAllocationAmount: number = +persistAllocatedAmount - +inputValue;
      setAllocatedAmount(finalAllocationAmount);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [
    showAllocationModal,
    allocationSingleRowData?.othersPaymentId,
    allAllocatedPaymentRowsData,
  ]);

  useEffect(() => {
    setIsEditOthersInvoicePresent("Edit Others Invoicing Advanced", "menu");
    setIsViewOthersViewInvoicePresent("View Other Invoicing Advanced", "menu");
    if (token && id && invoice_id) {
      let finalData: GetSingleOtherInvoiceDetailsPayloadType = {
        client_code: id,
        token,
        other_id: invoice_id,
      };
      setIsAddOthersInvoicePresent("Add Others Invoice", "menu");
      setIsApproveOthersInvoice("Approve Others Invoice", "menu");
      setIsAddOthersInvoiceComments("Add Others Invoice Comments", "menu");
      dispatchGetSingleOtherInvoiceDetails(finalData);
    }
  }, [invoice_id]);

  useEffect(() => {
    if (dateOfInvoice?.length) {
      let splitedInvoiceDate: string[] = formatDate(dateOfInvoice)?.split("-");
      let splitedLockedEntries: string | string[] = lockedOthersEntriesDate
        ? lockedOthersEntriesDate?.split("-")
        : "";
      let itemDate = new Date(
        +splitedInvoiceDate[2],
        +splitedInvoiceDate[1] - 1,
        +splitedInvoiceDate[0]
      );
      let lockedDate = new Date(
        +splitedLockedEntries[2],
        +splitedLockedEntries[1] - 1,
        +splitedLockedEntries[0]
      );
      if (itemDate <= lockedDate) {
        setIsEntryLocked(true);
      } else {
        setIsEntryLocked(false);
      }
    }
  }, [dateOfInvoice]);

  useEffect(() => {
    if (editData && Object.keys(editData)?.length > 0) {
      if (editData?.date_of_invoice && loginData?.user_type === 1) {
        let checkDate =
          editData?.date_of_invoice?.split("-").join(",") <=
          "2023-03-31"?.split("-").join(",");
        if (!checkDate) {
          setAuditSeasonMessage("");
        } else {
          setAuditSeasonMessage("You're entering the invoice of FY 2022-23");
        }
      }
      setIsEdit(true);
      setNarrationInBank(editData?.narration_in_bank);
      setDateOfInvoice(editData?.date_of_invoice);
      setUploadData(editData?.upload);
      setAdditionalComments(editData?.additional_comments);
      setBranch({
        label: editData?.branch_details?.trade_name,
        value: editData?.branch_details?.ledger_id,
      });

      let arr: ItemTypes[] = [];

      if (editData?.payment?.length > 0) {
        editData?.payment?.map((data: any) => {
          arr.push({
            transaction_type: {
              value: data?.transaction_type,
              label: TRANSACTION_TYPES.filter(
                (tt: TransactionType) => tt.value === data?.transaction_type
              )[0].label,
            },
            account_details: {
              value: data?.account_details,
              label: data?.account_details?.ledger_name,
            },
            amount: data?.amount?.toString(),
            others_payment_id: data?.others_payment_id,
            allocated_data: data?.allocation_details,
          });
        });
      }

      setItemData(arr);
    }
  }, [editData]);

  useEffect(() => {
    if (
      loginData?.user_id ||
      singleOtherInvoiceDetails?.approval_details?.length > 0
    ) {
      let user_id;
      if (loginData?.user_id) {
        user_id = checkSameUserId(
          loginData?.user_id,
          singleOtherInvoiceDetails?.approval_details
        );
      }
      let totalApprovedData =
        singleOtherInvoiceDetails?.approval_details?.length === 3;
      setApproved(user_id || totalApprovedData);
    }
  }, [loginData?.user_id, singleOtherInvoiceDetails?.approval_details]);

  useEffect(() => {
    if (showInvoiceCommentsModal && singleOtherInvoiceDetails) {
      let obj: any = {};
      obj["voucher_invoice_date"] = singleOtherInvoiceDetails?.date_of_invoice;
      obj["branch_details"] = singleOtherInvoiceDetails?.branch_details;

      setInvoiceData(obj);
      if (invoice_id && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type: "others",
          token,
          invoice_id,
          client_code,
        };
        dispatchGetAllInvoiceCommentsAction(finalData);
      }
    }
  }, [
    invoice_id,
    client_code,
    showInvoiceCommentsModal,
    singleOtherInvoiceDetails?.branch_details?.trade_name,
    singleOtherInvoiceDetails,
    singleOtherInvoiceDetails?.date_of_invoice,
    token,
    dispatchGetAllInvoiceCommentsAction,
  ]);

  useEffect(() => {
    setApproved(false);
    dispatchResetSingleOtherInvoiceDetailsAction();
    dispatchResetInvoiceGenerationError();
    dispatchResetInvoiceGenerationSuccess();
    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        data_req: "enabled",
      };

      dispatchGetAllLedgerListAction(finalData);
      dispatchGetAllBusinessAddressAction(finalData);
    }
    return () => toast.remove();
  }, []);

  useEffect(() => {
    if (paymentPendingList?.length || allAllocationList?.length) {
      let singleAllocatedRow = singleOtherInvoiceDetails?.payment?.find(
        (item: any, i: number) =>
          i + 1 == allocationSingleRowData?.othersPaymentId
      );
      let newIterableData = JSON.parse(JSON.stringify(paymentPendingList));
      let newAllAllocationList = JSON.parse(JSON.stringify(allAllocationList));
      let sum = 0;
      newIterableData?.map((item: any) => {
        let singleAllocatedAmount =
          singleAllocatedRow?.allocation_details?.find(
            (singleItem: any) => singleItem?.invoice_id == item?.invoice_id
          );
        sum += item.remaining_amount;
        item.singleAmount = singleAllocatedAmount?.allocation_amount
          ? singleAllocatedAmount?.allocation_amount
          : 0;
      });
      let filteredNewAllAllocationList: any[] = [];
      newAllAllocationList?.map((singleItem: any) => {
        let singleAllocatedAmount =
          singleAllocatedRow?.allocation_details?.find(
            (singleAllocatedItem: any) =>
              singleAllocatedItem?.invoice_id == singleItem?.invoice_id
          );
        let flag = false;
        newIterableData?.map((allocation: any) => {
          if (singleItem?.invoice_id == allocation?.invoice_id) {
            return (flag = true);
          }
        });
        if (flag === false) {
          filteredNewAllAllocationList.push({
            ...singleItem,
            singleAmount: singleAllocatedAmount?.allocation_amount,
          });
        }
      });

      newAllAllocationList?.map((item: any) => {
        item.singleAmount = item?.allocated_amount;
      });

      if (newIterableData?.length || filteredNewAllAllocationList?.length) {
        fillAllAllocationRow(
          newIterableData?.length && filteredNewAllAllocationList?.length
            ? [...newIterableData, ...filteredNewAllAllocationList]
            : newIterableData?.length
            ? [...newIterableData]
            : [...filteredNewAllAllocationList]
        );
        setPaymentPendingData(
          newIterableData?.length && filteredNewAllAllocationList?.length
            ? [...newIterableData, ...filteredNewAllAllocationList]
            : newIterableData?.length
            ? [...newIterableData]
            : [...filteredNewAllAllocationList]
        );
      }

      setRemainingAmount(sum);
    }
  }, [paymentPendingList, allAllocationList]);

  useEffect(() => {
    if (singleOtherInvoiceDetails?.payment?.length) {
      let obj: any = {};
      singleOtherInvoiceDetails?.payment?.map((item: any, i: number) => {
        obj[i + 1] = false;
      });
      setIsAllocatedRowClear({ ...obj });
    }
  }, [singleOtherInvoiceDetails]);

  const handleChangeAmount = (inputValue: number, id: number) => {
    let newIterableData = JSON.parse(JSON.stringify(paymentPendingData));

    let totalInputValue: number = 0;
    newIterableData?.map((item: any) => {
      if (item.invoice_id === id) {
        item.singleAmount = +inputValue;
      }
      totalInputValue += item?.singleAmount ? +item?.singleAmount : 0;
    });

    let finalAllocationAmount: number =
      +persistAllocatedAmount - +totalInputValue;
    setAllocatedAmount(finalAllocationAmount);
    let allocationId = allocationSingleRowData?.othersPaymentId;
    setIsAllocatedRowClear({ ...isAllocatedRowClear, [allocationId]: false });
    setAllAllocatedPaymentRowData({
      ...allAllocatedPaymentRowsData,
      [allocationId]: [...newIterableData],
    });
    setPaymentPendingData([...newIterableData]);
  };

  const handleGetAllocationData = (
    data: GetAllocationPayloadType,
    othersPaymentId: number,
    fullData: any
  ) => {
    setAllocationSingleRowData({ ...data, othersPaymentId: othersPaymentId });
    if (!allAllocatedPaymentRowsData[othersPaymentId]?.length) {
      dispatchGetPaymentPendingListAction(data);
      let finalData = {
        token,
        client_code: data?.client_code,
        id: fullData?.others_payment_id,
        type: fullData?.transaction_type?.value,
      };
      dispatchGetAllAllocationListAction(finalData);
    } else {
      setPaymentPendingData([...allAllocatedPaymentRowsData[othersPaymentId]]);
    }
  };

  const handleNarrationInBankChange = (e: any) => {
    setNarrationInBank(e.target.value);
    if (otherErrors?.narrationInBankError) {
      setOtherErrors((prevState) => ({
        ...prevState,
        narrationInBankError: "",
      }));
    }
  };

  const handleDateOfInvoiceChange = (date: any) => {
    if (date === "Invalid date") date = "";
    setDateOfInvoice(date);
    if (otherErrors?.dateOfInvoiceError) {
      setOtherErrors((prevState) => ({
        ...prevState,
        dateOfInvoiceError: "",
      }));
    }
    if (loginData?.user_type === 1) {
      let checkDate =
        date?.split("-").join(",") <= "2023-03-31"?.split("-").join(",");
      if (!checkDate) {
        setAuditSeasonMessage("");
      } else {
        setAuditSeasonMessage("You're entering the invoice of FY 2022-23");
      }
    }
  };

  const validateSubmitData = () => {
    for (let data in itemData) {
      if (
        itemData[data]?.amount === null ||
        !itemData[data]?.amount?.toString().length ||
        !itemData[data]?.transaction_type.hasOwnProperty("value") ||
        !itemData[data]?.account_details.hasOwnProperty("value")
      ) {
        return false;
      }
    }

    return true;
  };

  const validateAllocatedAmount = () => {
    for (let data in itemData) {
      if (itemData[data]?.allocated_data?.length) {
        let sum = 0;
        itemData[data]?.allocated_data?.map((item: any) => {
          sum += item?.allocation_amount;
        });
        if (sum > itemData[data]?.amount) {
          return false;
        }
      }
    }
    return true;
  };

  const handleAddEditOtherEntryData = () => {
    const isValidated = validateSubmitData();
    const checkAllocatedAmount = validateAllocatedAmount();
    if (!isValidated) {
      toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });
    } else if (totalAmount !== 0) {
      setTotalAmountError(true);
      toast.error("Total amount should always be 0", {
        duration: 3500,
      });
    } else if (!checkAllocatedAmount) {
      toast.error("Allocated amount is more than amount", {
        duration: 3500,
      });
    } else if (!dateOfInvoice?.length || branch?.value === undefined) {
      setOtherErrors((prevState) => ({
        ...prevState,
        ...(!dateOfInvoice?.length && {
          dateOfInvoiceError: "Required",
        }),
        ...(branch?.value === undefined && {
          branchError: "Please choose branch name",
        }),
      }));
    } else {
      setTotalAmountError(false);
      if (isEdit) {
        let finalPaymentData: OtherInvoiceGenerationPaymentType[] = [];
        let allocatedData = [];
        itemData?.map((item: any) => {
          if (item.hasOwnProperty("others_payment_id")) {
            let singleEditPaymentObj = singleOtherInvoiceDetails?.payment?.find(
              (singleItem: any) =>
                singleItem?.others_payment_id == item?.others_payment_id
            );
            allocatedData = item?.allocated_data?.length
              ? item?.allocated_data?.filter(
                  (singleItem: any) => !!singleItem?.allocation_amount
                )
              : [];

            if (
              singleEditPaymentObj &&
              singleEditPaymentObj?.account_details?.ledger_id !=
                item?.account_details?.value?.ledger_id
            ) {
              allocatedData = [];
            }
            finalPaymentData.push({
              others_payment_id: item?.others_payment_id,
              transaction_type: item?.transaction_type?.value,
              account_details: item?.account_details?.value,
              amount: item?.amount,
              allocation_data: allocatedData,
            });
          } else {
            let singleEditPaymentObj = singleOtherInvoiceDetails?.payment?.find(
              (singleItem: any) =>
                singleItem?.others_payment_id == item?.others_payment_id
            );
            allocatedData = item?.allocated_data?.length
              ? item?.allocated_data?.filter(
                  (singleItem: any) => !!singleItem?.allocation_amount
                )
              : [];

            if (
              singleEditPaymentObj &&
              singleEditPaymentObj?.account_details?.ledger_id !=
                item?.account_details?.value?.ledger_id
            ) {
              allocatedData = [];
            }
            finalPaymentData.push({
              transaction_type: item?.transaction_type?.value,
              account_details: item?.account_details?.value,
              amount: item?.amount,
              allocation_data: allocatedData,
            });
          }
        });

        let finalData: UpdateOtherInvoiceGenerationPayloadType = {
          others_invoice_id: editData?.others_id,
          token,
          client_code: id,
          branchDetails: {
            tradeName: branch?.label,
            ledgerId: branch?.value,
          },
          date_of_invoice: formatDate(dateOfInvoice),
          narration_in_bank: narrationInBank,
          payment: finalPaymentData,
          additional_comments: additionalComments,
          upload: uploadData,
        };
        dispatchUpdateOtherInvoiceGenerationAction(finalData);
      } else {
        let finalpaymentData: OtherInvoiceGenerationPaymentType[] = [];
        itemData?.map((item: any) => {
          finalpaymentData.push({
            transaction_type: item?.transaction_type?.value,
            account_details: item?.account_details?.value,
            amount: item?.amount,
          });
        });

        let finalData = {
          token,
          client_code,
          branchDetails: {
            tradeName: branch?.label,
            ledgerId: branch?.value,
          },
          date_of_invoice: formatDate(dateOfInvoice),
          narration_in_bank: narrationInBank,
          payment: finalpaymentData,
          additional_comments: additionalComments,
          upload: uploadData,
        };

        dispatchAddOtherInvoiceGenerationAction(finalData);
      }
    }
  };

  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleChange = (dataKey: any, value: any, index: number) => {
    let temp = itemData;
    temp[index][dataKey] = value;
    setItemData([...temp]);

    let sum = 0;

    if (dataKey === "amount" && totalAmount === 0 && totalAmountError) {
      setTotalAmountError(false);
    }

    if (dataKey === "amount") {
      itemData?.map((item: any) => {
        if (
          item?.transaction_type &&
          item?.transaction_type?.value === "credit"
        ) {
          sum = sum + +item?.amount;
        } else if (
          item?.transaction_type &&
          item?.transaction_type?.value === "debit"
        ) {
          sum = sum - item?.amount;
        }
      });

      setTotalAmount(sum.toFixed(2));
    }
    if (dataKey === "transaction_type") {
      itemData?.map((item: any) => {
        if (
          item?.transaction_type &&
          item?.transaction_type?.value === "credit"
        ) {
          sum = sum + +item?.amount;
        } else if (
          item?.transaction_type &&
          item?.transaction_type?.value === "debit"
        ) {
          sum = sum - item?.amount;
        }
      });

      setTotalAmount(sum.toFixed(2));
    }

    if (sum === 0) {
      setTotalAmountError(false);
    }
  };
  useEffect(() => {
    if (totalAmount == 0) {
      setTotalAmount(0);
    }
  }, [totalAmount]);
  const handleUploadFile = (data: any) => {
    if (!uploadData) {
      setUploadData([...data]);
    }
    setShowFileUploadModal(false);
    let oldFileUploadData = [...uploadData, ...data];

    let finalData = removeDuplicate(oldFileUploadData);

    setUploadData(Array.from(finalData));
  };

  const handleKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };

  const renderFilesList = () => {
    const isDelete = true;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        let file_type = data.file_url.split(".");
        return file_type[file_type.length - 1].toLowerCase() === "png" ||
          file_type[file_type.length - 1].toLowerCase() === "jpg" ||
          file_type[file_type.length - 1].toLowerCase() === "jpeg" ||
          file_type[file_type.length - 1].toLowerCase() === "doc" ||
          file_type[file_type.length - 1].toLowerCase() === "docx" ||
          file_type[file_type.length - 1].toLowerCase() === "xls" ||
          file_type[file_type.length - 1].toLowerCase() === "xlsx" ||
          file_type[file_type.length - 1].toLowerCase() === "pdf"
          ? imagePreview(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            )
          : downloadLink(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            );
      });

    return finalFileList;
  };

  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));

    const isFilePresent = tempFileData?.find((data: any, idx: number) => {
      return idx === index;
    });

    if (!!isFilePresent) {
      let newData = tempFileData?.filter(
        (data: any, idx: number) => idx !== index
      );
      setUploadData(newData);
    }
  };

  const handleRemoveRow = (i: number, index: any, dataKey: string) => {
    let temp = [...itemData];
    let oldAmount = temp.find((item: any) => index?.amount === item?.amount);

    let newTotal: any;
    if (oldAmount?.amount === null) {
      temp.splice(i, 1);
      setItemData(temp);
    } else {
      if (dataKey === "credit") {
        newTotal = totalAmount - oldAmount?.amount;
      } else if (dataKey === "debit") {
        newTotal = totalAmount + +oldAmount?.amount;
      }
      temp.splice(i, 1);
      setItemData(temp);
      setTotalAmount(newTotal);
    }
  };

  const fillAllAllocationRow = (paymentPendingData: any) => {
    if (itemData?.length) {
      let obj: any = {};
      itemData?.map((item: any, i: number) => {
        if (i + 1 == allocationSingleRowData?.othersPaymentId) {
          obj[i + 1] = paymentPendingData;
        } else {
          obj[i + 1] = allAllocatedPaymentRowsData[i + 1];
        }
      });

      setAllAllocatedPaymentRowData({ ...obj });
    }
  };

  function getAllocationData() {
    let allocationData: any = [];

    paymentPendingData?.map((item: any) => {
      let newObject: SingleAllocationPayloadListType = {
        invoice_id: null,
        allocation_amount: 0,
      };
      if (item?.invoice_id) {
        newObject.invoice_id = item.invoice_id;
      }
      if (item?.singleAmount > 0) {
        newObject.allocation_amount = item.singleAmount;
      }

      allocationData.push(newObject);
    });
    return allocationData;
  }

  const removeDuplicate = (data: any) => {
    let nonRepeatData: any = new Set();

    data?.forEach(
      (obj: any) =>
        !nonRepeatData.has(JSON.stringify(obj)) &&
        nonRepeatData.add(JSON.stringify(obj))
    );

    let finalData: any = new Set(
      [...nonRepeatData].map((item) => JSON.parse(item))
    );
    return finalData;
  };

  const handleUploadFileFromFileManager = (data: any) => {
    let finalData: any = removeDuplicate(data);
    setUploadData(Array.from(finalData));
  };

  const handleAddRow = () => {
    let temp: any = JSON.parse(JSON.stringify(itemData));
    temp.push(...JSON.parse(JSON.stringify(ITEM_DATA)));
    setItemData(temp);
  };

  const resetAllocationList = () => {
    dispatchResetPaymentPendingListAction();
    dispatchResetAllAllocationListAction();
  };

  const toggleAllocationModal = () => {
    if (showAllocationModal) {
      resetAllocationList();
      if (Object?.keys(allAllocatedPaymentRowsData)?.length) {
        setAllAllocatedPaymentRowData({ ...allAllocatedPaymentRowsData });
      }
    }
    return setShowAllocationModal((prev: any): boolean => !prev);
  };

  const toggleWithOutSavingData = () => {
    fillAllAllocationRow([]);
    setPaymentPendingData([]);
    let isSingleRowClear = allocationSingleRowData?.othersPaymentId;
    setIsAllocatedRowClear({
      ...isAllocatedRowClear,
      [isSingleRowClear]: false,
    });
  };

  const handleCancel = () => {
    let isSingleRowClear = allocationSingleRowData?.othersPaymentId;
    if (!isAllocatedRowClear[isSingleRowClear]) {
      fillAllAllocationRow([]);
      setPaymentPendingData([]);
    }
  };

  const handleSaveAllocatedAmount = () => {
    let newItemData = itemData?.map((item: any, i: number) => {
      if (i + 1 == allocationSingleRowData?.othersPaymentId) {
        return { ...item, allocated_data: getAllocationData() };
      } else {
        return { ...item };
      }
    });
    setItemData([...newItemData]);

    fillAllAllocationRow(paymentPendingData);
    toast.success("Please submit the invoice to save allocation !", {
      duration: 3500,
      icon: <img src={Warning} width={"15px"} height={"15px"} alt="warning" />,
      style: {
        backgroundColor: "#fff5e5",
        minWidth: "358px",
        color: "#be7e12",
        border: "solid 1px #be7e12",
      },
    });
    let isSingleRowClear = allocationSingleRowData?.othersPaymentId;
    setIsAllocatedRowClear({
      ...isAllocatedRowClear,
      [isSingleRowClear]: true,
    });
    setShowAllocationModal(!AllocationModal);
  };

  const closeTab = () => {
    localStorage.removeItem("isRedirected");
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  const handleGoBack = () => {
    toast.remove();
    if (redirection === "yes") {
      closeTab();
    }

    dispatchResetSingleOtherInvoiceDetailsAction();
    history?.push({
      pathname: `/invoice-generation/${clientCodeFromParams}#others`,
      state: {
        client_code: clientCodeFromParams,
        company_name: companyNameFromParams,
        searchOtherData,
        invoiceDataOtherValue,
        invoiceNumberOtherValue,
        otherComment,
        otherStartDate,
        otherEndDate,
        otherInvoiceStartDate,
        otherInvoiceEndDate,
        otherRadioValue,
        otherAttachement,
        otherApproval,
      },
    });

    localStorage.removeItem("client_code");
    localStorage.removeItem("company_name");
  };

  const option: any = businessAddressList?.map((item: any) => {
    return {
      label: item.trade_name,
      value: item.ledger_id,
    };
  });

  const handleChangeBranchName = (item: BranchType) => {
    setBranch({
      label: item?.label,
      value: item?.value,
    });
    if (item?.value) {
      setOtherErrors((prev: OtherErrorType) => ({
        ...prev,
        branchError: "",
      }));
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSessionAction()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationError();
            }}
          />
        );
      }
    }
    if (approvalSuccess === 1) {
      dispatchResetApprovalSuccess();
      toast.success("Approved Successfully!", {
        duration: 2000,
      });
      if (token && id && invoice_id) {
        let finalData: GetSingleOtherInvoiceDetailsPayloadType = {
          client_code: id,
          token,
          other_id: invoice_id,
        };
        dispatchGetSingleOtherInvoiceDetails(finalData);
      }
    }
    if (commentsSuccess === 1) {
      dispatchResetCommentsSuccess();
      toast.success("Comment Added Successfully!", {
        duration: 2000,
      });
      if (invoice_id && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type: "others",
          token,
          invoice_id,
          client_code,
        };
        dispatchGetAllInvoiceCommentsAction(finalData);
      }
    }

    if (success === 1) {
      const redirection = localStorage.getItem("isRedirected");
      if (redirection === "yes") {
        return (
          <RedirectErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={"Invoice Updated Successfully!"}
            statusCode={statusCode}
          />
        );
      } else {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={
              isEdit
                ? "Invoice Updated Successfully!"
                : "Invoice Added Successfully!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationSuccess();
              dispatchResetSingleOtherInvoiceDetailsAction();
              setIsEdit(false);
              // localStorage.hasOwnProperty("client_code")
              clientCodeFromParams
                ? handleGoBack()
                : history?.push({
                    pathname: `/invoice-generation/${client_code}#${"others"}`,
                    state: {
                      client_code: client_code,
                      company_name,
                      attachment,
                      approval,
                      searchOtherData,
                      invoiceDataOtherValue,
                      invoiceNumberOtherValue,
                      otherComment,
                      otherStartDate,
                      otherEndDate,
                      otherInvoiceStartDate,
                      otherInvoiceEndDate,
                      otherRadioValue,
                      otherAttachement,
                      otherApproval,
                    },
                  });
            }}
            statusCode={statusCode}
          />
        );
      }
    }

    return false;
  };
  const handleToggleInvoiceCommentsModal = () => {
    setShowInvoiceCommentsModal(!showInvoiceCommentsModal);
  };

  const handleApproval = () => {
    if (invoice_id && token) {
      let finalData = {
        client_code,
        type: "others",
        invoice_id,
        token,
      };
      dispatchApproveInvoice(finalData);
    }
  };
  const handleSubmitInvoiceComment = (data: any) => {
    if (token && invoice_id) {
      let finalData: AddCommentPayloadType = {
        client_code,
        token,
        type: "others",
        invoice_id,
        comments: data?.commentText,
      };

      dispatchPostAllInvoiceCommentsAction(finalData);
    }
  };

  return (
    <>
      {imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
        />
      )}
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader
            title={`${
              isEdit ? "Update Invoice Details" : "Add Invoice Details"
            }`}
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      </div>
      <div className="content-area">
        <OtherEntryForm
          allLedgersList={allLedgersList}
          handleNarrationInBankChange={handleNarrationInBankChange}
          handleDateOfInvoiceChange={handleDateOfInvoiceChange}
          narrationInBank={narrationInBank}
          dateOfInvoice={dateOfInvoice}
          itemData={itemData}
          handleChange={handleChange}
          handleRemoveRow={handleRemoveRow}
          totalAmount={totalAmount}
          otherErrors={otherErrors}
          client_code={client_code}
          branch={branch}
          option={option}
          token={token}
          isEdit={isEdit}
          handleChangeBranchName={handleChangeBranchName}
          handleKeyPress={handleKeyPress}
          auditSeasonMessage={auditSeasonMessage}
          currencySign={currencySign}
          toggleAllocationModal={toggleAllocationModal}
          handleGetAllocationData={handleGetAllocationData}
          setAllocatedAmount={setAllocatedAmount}
          setPersistAllocatedAmount={setPersistAllocatedAmount}
          resetAllocationList={resetAllocationList}
        />

        <hr />
        <div className="row mt-3">
          <div className="col-6">
            <button className="btn btn-outline btn-sm" onClick={handleAddRow}>
              <span>
                <PlusIconCircle /> Add More
              </span>
            </button>
          </div>
          <div className="col-6">
            <div className="d-flex flex-column">
              <span>
                Total Amount: {currencySign} {totalAmount}
              </span>
              <p
                className={`due-date-text ${
                  totalAmountError ? "text-danger" : ""
                }`}
              >
                (Note: Total amount should always be equal to 0)
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <form>
              <div className="form-group">
                <div className="w-75">
                  <label
                    htmlFor="Narration in Bank"
                    className={additionalComments ? "active" : ""}
                  >
                    Additional Comments
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="narrationInBank"
                    value={additionalComments}
                    onChange={(e) => setAdditionalComments(e.target.value)}
                    onKeyDown={(e) => handleKeyPress(e)}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            {!!uploadData?.length && (
              <div className="pointer">
                <span id="Popover1">
                  <PaperClipIcon />
                  <span className="badge count-badge">
                    {uploadData?.length}
                  </span>
                </span>
                {renderUploadedFiles(
                  showPopUpContentModal,
                  setShowPopUpContentModal,
                  renderFilesList
                )}
              </div>
            )}
            <button
              className="btn btn-sm btn-outline mt-3"
              onClick={handleToggleFileUploadModal}
            >
              <span>
                <UploadNew /> Upload Files
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* //approval module */}
      {isEdit && (isApproveOthersInvoice || isAddOthersInvoiceComments) && (
        <div className="card mt-2">
          <div className="card-body">
            <div className="approve-details">
              <div>
                <h6>Approval Details</h6>
                {
                  <div>
                    {isApproveOthersInvoice && (
                      <Button
                        disabled={approved}
                        className="mr-2"
                        onClick={() => {
                          handleApproval();
                        }}
                      >
                        <img src={Verified} alt="verified" />
                        {approved ? "Approved" : " Approve This Entry"}
                      </Button>
                    )}
                    {isAddOthersInvoiceComments && (
                      <Button
                        className="btn"
                        onClick={handleToggleInvoiceCommentsModal}
                      >
                        Add Comment
                      </Button>
                    )}
                  </div>
                }
              </div>
              <div>
                {singleOtherInvoiceDetails?.approval_details?.length > 0 && (
                  <p>Previously approved by</p>
                )}
                <div style={{ display: "flex", gap: "3%" }}>
                  {singleOtherInvoiceDetails?.approval_details?.length > 0 &&
                    singleOtherInvoiceDetails?.approval_details?.map(
                      (approvalProfile: any) => {
                        let fullName =
                          approvalProfile?.first_name +
                          " " +
                          approvalProfile?.last_name;
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {fullName}
                                <br></br>
                                approved on{" "}
                                {formateDateWithTime(
                                  approvalProfile?.approved_at
                                )}
                              </Tooltip>
                            }
                          >
                            <span>
                              {" "}
                              <Avatar
                                name={fullName}
                                image={approvalProfile?.profile_pic?.file_url}
                              />
                            </span>
                          </OverlayTrigger>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            onClick={
             
              clientCodeFromParams
                ? handleGoBack
                : () => {
                    history?.push({
                      pathname: `/invoice-generation/${client_code}#${"others"}`,
                      state: {
                        client_code: client_code,
                        company_name,
                        attachment,
                        approval,
                        searchOtherData,
                        invoiceDataOtherValue,
                        invoiceNumberOtherValue,
                        otherComment,
                        otherStartDate,
                        otherEndDate,
                        otherInvoiceStartDate,
                        otherInvoiceEndDate,
                        otherRadioValue,
                        otherAttachement,
                        otherApproval,
                      },
                    });
                    dispatchResetSingleOtherInvoiceDetailsAction();
                    toast.remove();
                  }
            }
            className="mr-3 btn btn-outline-dark"
          >
            {isEditOthersInvoicePresent &&
            !singleOtherInvoiceDetails?.is_lock &&
            !isEntryLocked
              ? `Cancel`
              : `Exit`}
          </button>
          {(isAddOthersInvoicePresent || isEditOthersInvoicePresent) &&
          !singleOtherInvoiceDetails?.is_lock &&
          !isEntryLocked ? (
            <button
              className="btn btn-primary"
              onClick={handleAddEditOtherEntryData}
            >
              {isEdit ? "Update Details" : "Submit"}
            </button>
          ) : null}
        </div>
      </div>

      {showFileUploadModal && (
        <UploadModalWithFileManager
          type={"invoice"}
          isDropZone={true}
          isEdit={isEdit}
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          client_code={client_code}
          setUploadData={setUploadData}
          uploadData={uploadData}
          token={token}
          setShowFileUploadModal={setShowFileUploadModal}
          handleUploadFile={handleUploadFile}
          handleUploadFileFromFileManager={handleUploadFileFromFileManager}
          fetching={fileManagerFetching}
          isDraggableModal
        />
      )}
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
      {showInvoiceCommentsModal && (
        <InvoiceCommentsModal
          modal={showInvoiceCommentsModal}
          toggleModal={handleToggleInvoiceCommentsModal}
          data={invoiceData}
          commentList={allComments}
          handlePostComment={handleSubmitInvoiceComment}
        />
      )}
      {showAllocationModal && (
        <AllocationModal
          toggleAllocationModal={toggleAllocationModal}
          isOpen={showAllocationModal}
          allAllocatedPaymentRowsData={allAllocatedPaymentRowsData}
          allocatedAmount={allocatedAmount}
          currencySign={currencySign}
          remainingAmount={remainingAmount}
          handleChangeAmount={handleChangeAmount}
          toggleWithOutSavingData={toggleWithOutSavingData}
          handleSaveAllocatedAmount={handleSaveAllocatedAmount}
          allocationSingleRowData={allocationSingleRowData}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  statuscode: state.invoiceGeneration.statusCode,
  allLedgersList: state.clientSettings.allTypesLedgersWithTaxList,
  fileManagerFetching: state.fileManager.fetching,
  singleOtherInvoiceDetails: state.invoiceGeneration.singleOtherInvoiceDetails,
  businessAddressList: state.clientSettings.businessAddressList,
  loginData: state.auth.loginData,
  commentsSuccess: state.invoiceGeneration.commentsSuccess,
  approvalSuccess: state.invoiceGeneration.approvalSuccess,
  allComments: state.invoiceGeneration.allComments,
  currencySign: state.auth.currencySign,
  paymentPendingList: state.invoiceGeneration.paymentPendingList,
  allAllocationList: state.invoiceGeneration.allAllocationList,
  lockedOthersEntriesDate: state.invoiceGeneration.lockOthersEntriesDate,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
  dispatchAddOtherInvoiceGenerationAction: (
    data: AddOtherInvoiceGenerationPayloadType
  ) => dispatch(addOtherInvoiceGenerationAction(data)),
  dispatchUpdateOtherInvoiceGenerationAction: (
    data: UpdateOtherInvoiceGenerationPayloadType
  ) => dispatch(updateOtherInvoiceGenerationAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceGenerationError: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetInvoiceGenerationSuccess: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchGetSingleOtherInvoiceDetails: (
    data: GetSingleOtherInvoiceDetailsPayloadType
  ) => dispatch(getSingleOtherInvoiceDetailsAction(data)),
  dispatchResetSingleOtherInvoiceDetailsAction: () =>
    dispatch(resetSingleOtherInvoiceDetails()),
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) =>
    dispatch(approveInvoiceAction(data)),
  dispatchResetCommentsSuccess: () => dispatch(resetcommentsSuccess()),
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) =>
    dispatch(getInvoiceAllComment(data)),
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) =>
    dispatch(postInvoiceAllComment(data)),
  dispatchResetApprovalSuccess: () => dispatch(resetApprovalSuccess()),
  dispatchGetPaymentPendingListAction: (data: GetAllocationPayloadType) =>
    dispatch(getPaymentPendingList(data)),
  dispatchGetAllAllocationListAction: (data: GetAllocationPayloadType) =>
    dispatch(getAllAllocationListAction(data)),
  dispatchResetPaymentPendingListAction: () => dispatch(resetAllocationList()),
  dispatchResetAllAllocationListAction: () =>
    dispatch(resetAllAllocationList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditOtherEntryInvoice);
